import { render, staticRenderFns } from "./SearchConcepts.vue?vue&type=template&id=37a825f4&"
import script from "./SearchConcepts.vue?vue&type=script&lang=ts&"
export * from "./SearchConcepts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports